// Registre Stimulus explicite.
//
// L'auto-chargement se faisait avec require.context + definitionsFromContext,
// une API propre à webpack : elle disparaîtrait au passage à esbuild. Les
// contrôleurs sont peu nombreux, on les déclare donc un par un.
//
// ⚠️ Les identifiants doivent correspondre EXACTEMENT aux `data-controller`
// des vues : les noms de fichiers en snake_case deviennent des tirets
// (filter_program_controller.js → "filter-program").

import { Application } from "@hotwired/stimulus";
import { Multiselect } from "@wizardhealth/stimulus-multiselect";

import AutocompleteController from "./autocomplete_controller";
import CampusDetailsController from "./campus_details_controller";
import ClipboardController from "./clipboard_controller";
import DatepickerController from "./datepicker_controller";
import FilterProgramController from "./filter_program_controller";
import InlineEditController from "./inline_edit_controller";
import ProposalsController from "./proposals_controller";
import QuickSearchController from "./quick_search_controller";

const application = Application.start();

application.register("multiselect", Multiselect);
application.register("autocomplete", AutocompleteController);
application.register("campus-details", CampusDetailsController);
application.register("clipboard", ClipboardController);
application.register("datepicker", DatepickerController);
application.register("filter-program", FilterProgramController);
application.register("inline-edit", InlineEditController);
application.register("proposals", ProposalsController);
application.register("quick-search", QuickSearchController);

export { application };
